import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterElectricAutonomySearchValueObject extends ValueObject {
  #electricAutonomy

  constructor({electricAutonomy}) {
    super()
    this.#electricAutonomy = electricAutonomy
  }

  static create({electricAutonomy}) {
    return new FilterElectricAutonomySearchValueObject({
      electricAutonomy: FilterRangeSearchValueObject.create(electricAutonomy)
    })
  }

  static createWithDefaultValue({config, electricAutonomy}) {
    const {DEFAULT_ELECTRIC_AUTONOMY_SEARCH} = config.get('searchFilters')

    return new FilterElectricAutonomySearchValueObject({
      electricAutonomy: FilterRangeSearchValueObject.create({
        from: electricAutonomy?.from || DEFAULT_ELECTRIC_AUTONOMY_SEARCH.from,
        to: electricAutonomy?.to || DEFAULT_ELECTRIC_AUTONOMY_SEARCH.to
      })
    })
  }

  static createQueryParams({config, electricAutonomy}) {
    const {DEFAULT_ELECTRIC_AUTONOMY_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterElectricAutonomySearchValueObject({
      electricAutonomy: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_AUTONOMY].from,
          value: electricAutonomy?.from || DEFAULT_ELECTRIC_AUTONOMY_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_AUTONOMY].to,
          value: electricAutonomy?.to || DEFAULT_ELECTRIC_AUTONOMY_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#electricAutonomy.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#electricAutonomy.from.isEmpty && {...this.#electricAutonomy.from.queryParam}),
      ...(!this.#electricAutonomy.to.isEmpty && {...this.#electricAutonomy.to.queryParam})
    }
  }

  get value() {
    return this.#electricAutonomy.value
  }

  toJSON() {
    return {
      electricAutonomy: this.#electricAutonomy.toJSON()
    }
  }
}
